
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's144508ac0e146c46': `Hiçbir Sonuç Bulunamadı`,
's3f9c368cd44f682b': `Bir hata oluştu`,
's5d929ff1619ac0c9': `Arama`,
's716a6024e3fe999c': `Göster`,
's761665218da1556a': `Açılır menüyü aç`,
's76ddb3a843ed8e06': `Aramayı Temizle`,
's859e1270b0736efc': `Açılır menüyü kapat`,
's8bf9dd3eac79af25': `Şu anda görüntülenecek kayıt bulunmamaktadır.`,
'sa26d7a273074cbf9': `Veri bulunamadı`,
'sb1ba2131b9a7c7b0': `Git`,
'sbaace8219b5f4612': `Tümünü Seç`,
    };
  